export default __webpack_public_path__ + "assets/images/4a36b078fbee5156a0df2578ba6dc496.png";